import { Box, Divider } from '@mui/material';
import styles from './page.module.scss';
import { getClassName } from 'src/Core/utility/jsx';

const Page = ({ pageData, recognizedData }) => {
  const { pageNumber: pIndex, textBlocks } = pageData ?? {};

  const pageNumber = pIndex + 1;
  const recognizedDataBoundries = recognizedData
    ?.map((i) => i.recognizedData)
    ?.filter((i) => !!i.relativeData?.length)
    ?.map((i) => ({ ...i, pageNumber: i.relativeData?.[0]?.pageNumber }))
    ?.flatMap((i) => [i, ...i.relativeData])
    .map((i) => {
      return {
        Y1: i.boundry.bottomY,
        X1: i.boundry.rightX,
        Y0: i.boundry.topY,
        X0: i.boundry.x,
        pageNumber: i.pageNumber,
      };
    });

  const textLines = textBlocks
    ?.flatMap((i) => i.lines)
    .filter((i) => !i.isBlock)
    .map((i) => {
      const recBoundry = recognizedDataBoundries.find((recB) => {
        return (
          recB.pageNumber === pageNumber &&
          Number(recB.X0) <= Number(i.boundry.X0) &&
          Number(recB.X1) >= Number(i.boundry.X1) &&
          Number(recB.Y0) <= Number(i.boundry.Y0) &&
          Number(recB.Y1) >= Number(i.boundry.Y1)
        );
      });

      return {
        ...i,
        isRecognized: !!recBoundry,
      };
    });

  return (
    <div className={styles.container}>
      <PageDivider number={pageNumber} />
      {textLines
        .map((i) => {
          return (
            <div
              key={i.text}
              className={getClassName([
                styles.textElement,
                { [styles.isRecognized]: i.isRecognized },
              ])}
              style={{ top: `${i.boundry.Y0}px`, left: `${i.boundry.X0}px` }}
            >
              {i.text}
            </div>
          );
        })}
    </div>
  );
};

const PageDivider = ({ number }) => {
  return (
    <div>
      <Box pt={1} className={styles.pageDivider}>
        <div className={styles.pageNumber}>страница {number}</div>
        <Divider variant="fullWidth" />
      </Box>
    </div>
  );
};

export default Page;
